<template lang="pug" src="./systemLogs.pug"></template>
<style lang="scss" src="./systemLogs.scss" scoped></style>

<script>
import { mapState, mapGetters } from 'vuex'
import validationMixin from '@/mixins/validate'
import scroll from '@/utils/scroll'
import { checkType } from './helpers/translation'

export default {
    mixins: [validationMixin],
    data: () => ({
        filters: {
            fromDate: null,
            toDate: null,
            email: null,
            types: []
        },
        sorting: {}
    }),
    computed: {
        ...mapGetters['type'],
        ...mapState({
            systemLogs: state => state.systemLogs.systemLogs,
            pagination: state => state.systemLogs.pagination,
            appliedFilters: state => state.systemLogs.filters,
            isTableLoad: state => state.systemLogs.isLoaded,
            types: state => state.systemLogs.types
        }),
        headers() {
            return [
                { text: 'date', value: '"createdAt"' },
                { text: 'user', value: '"account"."email"' },
                { text: 'actionType', value: '"actionType"."name" ' },
                { text: 'action', sortable: false }
            ].map(it => Object.assign(it, {
                text: this.$vuetify.t(`$vuetify.pages.SystemLogs.table.${it.text}`)
            }))
        },
        actionTypes() {
            return this.types.map(it => ({
                text: this.$vuetify.t(`$vuetify.pages.SystemLogs.types.${it.name}`),
                value: it.id
            }))
        },
        filtered() {
            return this.actionTypes.filter(({ value }) => this.filters.types.includes(value)).map('text').join('\n')
        },
        translatedData() {
            return this.systemLogs.map(it => ({
                ...it,
                text: this.translation(it.actionType.name, it)
            }))
        }
    },
    watch: {
        sorting: {
            handler() {
                this.getSystemLogsByPage()
            },
            deep: true
        }
    },
    created: function() {
        this.filters = Object.assign({}, this.appliedFilters)
        this.$store.dispatch('systemLogs/getTypes')
        this.getSystemLogsByPage(this.pagination.page)
    },
    beforeRouteLeave: function(to, from, next) {
        this.$store.commit('systemLogs/SET_PAGINATION', { page: 1, length: null })
        this.$store.commit('systemLogs/RESET_SYSTEM_LOGS')
        next()
    },
    methods: {
        reset() {
            this.filters = Object.assign({}, {
                fromDate: null,
                toDate: null,
                email: null,
                types: []
            })
            this.$store.commit('systemLogs/RESET_SYSTEM_LOGS')
            this.getSystemLogsByPage()
        },
        onPageChange(page) {
            if (page !== this.pagination.page) {
                this.getSystemLogsByPage(page, true)
            }
        },
        changeFromDate(date) {
            this.filters.fromDate = date
        },
        changeToDate(date) {
            this.filters.toDate = date
        },
        submit() {
            this.$store.commit('systemLogs/SET_FILTERS', Object.assign({}, this.filters))
            this.getSystemLogsByPage()
        },
        getSystemLogsByPage(page = 1, isScrollEnable = false, excel = false) {
            this.$store.dispatch('systemLogs/getSystemLogs', {
                page,
                excel,
                column: this.sorting.sortBy,
                direction: this.sorting.descending ? 'desc' : 'asc',
                ...this.appliedFilters
            }).then(_ => {
                if (isScrollEnable) {
                    scroll(this.$refs.table)
                }
            })
        },
        translation(type, action) {
            return checkType.call(this, type, action)
        }
    }
}
</script>
